/* eslint-disable react/require-default-props */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prettier/prettier */
import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import ScaleLoader from "react-spinners/ScaleLoader";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import styled from "styled-components";
import { createStyles, makeStyles, withStyles } from "@material-ui/core/styles";
import { redesignTheme } from "../theme/theme";

type StyleProps = {
  height?: string;
  paddingleft?: string;
  paddingright?: string;
  width?: string;
};

const StyledTableBodyCell = withStyles(() => {
  return {
    body: {
      fontSize: redesignTheme.fontSize[50],
      fontFamily: redesignTheme.fontFamily.interface,
      color: redesignTheme.color.gray900,
      borderBottom: `1px solid ${redesignTheme.color.grayAlpha100}`,
      borderTop: `1px solid ${redesignTheme.color.grayAlpha100}`,
      height: "27px",
      paddingTop: redesignTheme.spacing[4.5],
      paddingBottom: redesignTheme.spacing[4.5],
      paddingLeft: (props: StyleProps): string => {
        return props.paddingleft || "auto";
      },
      paddingRight: (props: StyleProps): string => {
        return props.paddingright || "auto";
      },
      "& .MuiIconButton-root": {
        height: "24px",
        width: "24px",
        "&:hover": {
          backgroundColor: redesignTheme.color.grayAlpha100,
        },
      },
    },
  };
})(TableCell);

const StyledTableBodyCollapsibleCell = withStyles(() => {
  return {
    body: {
      fontSize: redesignTheme.fontSize[1],
      fontFamily: redesignTheme.fontFamily.interface,
      color: redesignTheme.color.gray600,
      border: "none",
      height: 18,
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: (props: StyleProps): string => {
        return props.paddingleft || "auto";
      },
      paddingRight: (props: StyleProps): string => {
        return props.paddingright || "auto";
      },
      "&.first-row": {
        paddingTop: 12,
      },
      "&.last-row": {
        paddingBottom: 12,
      },
    },
  };
})(TableCell);

const renderTableCells = (
  headers,
  row,
  collapsible,
  className = ""
): React.ReactElement => {
  const getStyledComponent = (header, accessor): React.ReactElement => {
    return collapsible ? (
      <StyledTableBodyCollapsibleCell
        align={header.align}
        className={className}
        paddingleft={header.paddingLeft}
        paddingright={header.paddingRight}
      >
        {row[accessor]}
      </StyledTableBodyCollapsibleCell>
    ) : (
      <StyledTableBodyCell
        align={header.align}
        key={accessor}
        paddingleft={header.paddingLeft}
        paddingright={header.paddingRight}
      >
        {row[accessor]}
      </StyledTableBodyCell>
    );
  };
  return (
    <>
      {headers.map((header) => {
        const { accessor } = header;
        return getStyledComponent(header, accessor);
      })}
    </>
  );
};

type BaseRowProps = {
  collapsibleRowDataAccessor?: string;
  fetchCollabsibleData?: (param: string) => void;
  headers: {
    accessor: string;
    align: string;
    paddingLeft?: string;
    paddingRight?: string;
    srOnly?: string;
    text: string;
    width?: string;
  };
  row: {
    collapsibleDataCount?: number;
    hasCollapsibleData?: boolean;
    id: string;
  };
};

const BaseRow = ({
  collapsibleRowDataAccessor,
  fetchCollabsibleData,
  headers,
  row,
}: BaseRowProps): React.ReactElement => {
  const [open, setOpen] = React.useState(false);
  const collapsible = false;
  const tableHasCollabsibleRows = !!collapsibleRowDataAccessor;
  const rowHasCollapsibleRows =
    tableHasCollabsibleRows &&
    row.hasCollapsibleData &&
    row.collapsibleDataCount <= 200;

  return (
    <>
      <TableRow>
        {tableHasCollabsibleRows && (
          <StyledTableBodyCell>
            {rowHasCollapsibleRows && (
              <IconButton
                aria-label={open ? "collapse row" : "expand row"}
                data-testid={`expand-collapse-button-${row.id}`}
                size="small"
                onClick={async (): Promise<void> => {
                  const newState = open ? "closed" : "open";
                  if (newState === "open") {
                    await fetchCollabsibleData(row.id);
                  }

                  setOpen(!open);
                }}
              >
                {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
              </IconButton>
            )}
          </StyledTableBodyCell>
        )}
        {renderTableCells(headers, row, collapsible)}
      </TableRow>
      {open && rowHasCollapsibleRows && (
        <CollapsibleRows
          headers={headers}
          rows={row[collapsibleRowDataAccessor]}
        />
      )}
    </>
  );
};

BaseRow.defaultProps = {
  collapsibleRowDataAccessor: "",
};

const CollapsibleRows = ({ headers, rows }): React.ReactElement => {
  if (rows.length === 0) {
    return (
      <TableRow
        data-testid="collabsible-row-no-data"
        key={"collapsible-row-no-data"}
        style={{ paddingTop: 6, paddingBottom: 6 }}
      >
        <StyledTableBodyCell />
        <StyledTableBodyCell style={{ color: redesignTheme.color.red500 }}>
          Something went wrong.
        </StyledTableBodyCell>
      </TableRow>
    );
  }

  const collapsible = true;
  return rows.map((row, index) => {
    let className = "";
    if (index === 0) className = "first-row";
    if (index === rows.length - 1) className = "last-row";
    return (
      <TableRow
        data-testid={`collapsible-row-${index}`}
        key={`collapsible-row-${index}`}
        style={{ paddingTop: 6, paddingBottom: 6 }}
      >
        <StyledTableBodyCollapsibleCell />
        {renderTableCells(headers, row, collapsible, className)}
      </TableRow>
    );
  });
};

const StyledTableHeaderCell = withStyles(() => {
  return createStyles({
    head: {
      backgroundColor: redesignTheme.color.white,
      fontFamily: redesignTheme.fontFamily.interface,
      fontWeight: redesignTheme.fontWeight.semibold,
      fontSize: redesignTheme.fontSize[1],
      color: redesignTheme.color.gray900,
      border: "none",
      height: 42,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: (props: StyleProps): string => {
        return props.paddingleft || "auto";
      },
      paddingRight: (props: StyleProps): string => {
        return props.paddingright || "auto";
      },
      width: (props: StyleProps): string => {
        return props.width || "auto";
      },
    },
  });
})(TableCell);

const renderHeaders = (
  headers,
  tableHasCollabsibleRows
): React.ReactElement => {
  return (
    <>
      {tableHasCollabsibleRows && (
        <StyledTableHeaderCell width="15px">
          <p className="sr-only">Expand Column Header</p>
        </StyledTableHeaderCell>
      )}
      {headers.map((header) => {
        return (
          <StyledTableHeaderCell
            align={header.align}
            data-testid={`${header.accessor}-header`}
            key={`header-${header.accessor}`}
            paddingleft={header.paddingLeft}
            paddingright={header.paddingRight}
            width={header.width}
          >
            {header.srOnly ? (
              <p className="sr-only">{header.srOnly}</p>
            ) : (
              header.text
            )}
          </StyledTableHeaderCell>
        );
      })}
    </>
  );
};

const renderBaseRows = (
  collapsibleRowDataAccessor,
  headers,
  rows,
  fetchCollabsibleData
): React.ReactElement => {
  return (
    <>
      {rows.map((row, index) => {
        return (
          <BaseRow
            collapsibleRowDataAccessor={collapsibleRowDataAccessor}
            fetchCollabsibleData={fetchCollabsibleData}
            headers={headers}
            key={`row-${index}-${row.id}`}
            row={row}
          />
        );
      })}
    </>
  );
};

const StyledTablePagination = withStyles(() => {
  return createStyles({
    toolbar: {
      padding: "0",
      width: "350px",
      alignItems: "center",
      margin: "0 auto",
    },
    caption: {
      fontFamily: redesignTheme.fontFamily.interface,
      fontSize: redesignTheme.fontSize[1],
      color: redesignTheme.color.gray900,
      marginBottom: "0",
    },
    select: {
      fontFamily: redesignTheme.fontFamily.interface,
      fontSize: redesignTheme.fontSize[1],
      color: redesignTheme.color.gray900,
      paddingTop: redesignTheme.spacing[3.5],
      "&:focus": {
        background: "transparent",
      },
    },
    selectIcon: {
      top: "9px",
    },
    actions: {
      "& .MuiIconButton-root": {
        height: "24px",
        width: "24px",
        margin: "0 6px",
        backgroundColor: redesignTheme.color.grayAlpha100,
        "&:hover": {
          backgroundColor: redesignTheme.color.grayAlpha200,
        },
      },
      "& .MuiSvgIcon-root": {
        fontSize: redesignTheme.fontSize[150],
      },
    },
  });
})(TablePagination);

const selectMenuStyles = makeStyles(() => {
  return createStyles({
    list: {
      "& .MuiTablePagination-menuItem": {
        fontFamily: redesignTheme.fontFamily.interface,
        fontSize: redesignTheme.fontSize[1],
        color: redesignTheme.color.gray900,
        display: "flex",
        padding: "6px 16px",
        "&:hover": {
          backgroundColor: redesignTheme.color.grayAlpha200,
        },
      },
      "& .MuiTablePagination-menuItem.Mui-selected": {
        backgroundColor: redesignTheme.color.grayAlpha100,
        "&:hover": {
          backgroundColor: redesignTheme.color.grayAlpha200,
        },
      },
    },
  });
});

// NOTE: Setting a dynamic height to prevent the page from jumping around
// while fetching data for the next page
const StyledLoaderContainer = styled.div`
  padding: ${(props): string => {
    return `${props.style.padding}px 0`;
  }};
  text-align: center;
`;

const getPadding = (rowsPerPage): number => {
  if (rowsPerPage > 10) {
    return 10 * 25;
  }
  return rowsPerPage * 25;
};

const StyledTableContainer = withStyles(() => {
  return createStyles({
    root: {
      height: (props: StyleProps): string => {
        return props.height;
      },
      scrollbarWidth: "none" /* Firefox */,
      "&::-webkit-scrollbar": {
        display: "none",
      } /* Chrome */,
    },
  });
})(TableContainer);

type CollapsibleTableProps = {
  collapsibleRowDataAccessor?: string;
  fetchCollabsibleData?: (param?: string) => void;
  handlePaginationChange?: (value: number) => void;
  handleRowsPerPageChange?: (event: any) => void;
  headers: {
    accessor: string;
    align: string;
    paddingLeft?: string;
    paddingRight?: string;
    srOnly?: string;
    text: string;
    width?: string;
  };
  hidePagination?: boolean;
  loading?: boolean;
  pageNumber?: number;
  rowCount?: number;
  rows: {
    hasCollapsibleData?: boolean;
    id: string;
  }[];
  rowsPerPage?: number;
  rowsPerPageOptions?: number[];
  stickyHeader?: boolean;
};

const CollapsibleTable = ({
  collapsibleRowDataAccessor,
  fetchCollabsibleData,
  handlePaginationChange,
  handleRowsPerPageChange,
  headers,
  hidePagination,
  loading,
  pageNumber,
  rowCount,
  rows,
  rowsPerPage,
  rowsPerPageOptions,
  stickyHeader,
}: CollapsibleTableProps): React.ReactElement => {
  const tableHasCollabsibleRows = !!collapsibleRowDataAccessor;
  const showPagination = !hidePagination;

  // MUI starts at index 0, our endpoint starts at 1
  const page = pageNumber - 1;
  const handlePageChange = (event, value): void => {
    handlePaginationChange(value + 1);
  };

  return (
    <>
      <StyledTableContainer style={{ height: stickyHeader ? "100vh" : "auto" }}>
        <Table stickyHeader={stickyHeader} aria-label="collapsible table">
          <TableHead>
            <TableRow>
              {renderHeaders(headers, tableHasCollabsibleRows)}
            </TableRow>
          </TableHead>
          {!loading && (
            <>
              <TableBody>
                {renderBaseRows(
                  collapsibleRowDataAccessor,
                  headers,
                  rows,
                  fetchCollabsibleData
                )}
              </TableBody>
              {showPagination && (
                <TableFooter>
                  <TableRow>
                    <StyledTablePagination
                      backIconButtonText={`${i18n.translate(
                        "admin_pages.activity.previous_page"
                      )}`}
                      count={rowCount}
                      labelRowsPerPage={`${i18n.translate(
                        "admin_pages.activity.rows_per_page"
                      )}:`}
                      nextIconButtonText={`${i18n.translate(
                        "admin_pages.activity.next_page"
                      )}`}
                      onPageChange={handlePageChange}
                      onRowsPerPageChange={handleRowsPerPageChange}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      rowsPerPageOptions={rowsPerPageOptions}
                      SelectProps={{
                        MenuProps: {
                          classes: {
                            list: selectMenuStyles().list,
                          },
                        },
                      }}
                    />
                  </TableRow>
                </TableFooter>
              )}
            </>
          )}
        </Table>
      </StyledTableContainer>
      {loading && (
        <StyledLoaderContainer
          data-testid="loader"
          style={{ padding: `${getPadding(rowsPerPage)}` }}
        >
          <ScaleLoader
            color={redesignTheme.color.gray900}
            loading={loading}
            height={30}
            width={4}
            margin={4}
          />
        </StyledLoaderContainer>
      )}
    </>
  );
};

CollapsibleTable.defaultProps = {
  collapsibleRowDataAccessor: "",
  hidePagination: false,
  loading: false,
  pageNumber: 1,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 25, 50],
  stickyHeader: false,
};

export default CollapsibleTable;
